import React from 'react';
import styled, { css } from 'styled-components';
import { colors, shadows } from 'src/config/colors';
import { typography } from 'src/config/typography';
import YouTubeIcon from 'src/assets/icons/YouTubeIcon';
import { media } from 'src/config/breakpoints';
import { youtubeChannel } from 'src/config/globals';

const Box = styled.div<{ leftPanel?: boolean }>`
  display: none;
  position: fixed;
  top: 3.75rem;
  right: 0;
  z-index: 2500;
  justify-content: space-between;
  align-items: center;
  width: 10.3125rem;
  padding: 0.625rem 0.4375rem 0.625rem 0.625rem;
  border-radius: 0.375rem 0 0 0.375rem;
  box-shadow: ${shadows.drop1};
  background: ${colors.darkGrey};

  ${media.w.between.px576.px992(css`
    display: flex;
  `)}

  ${media.w.min.px768(css`
    top: 4.375rem;
  `)}
`;

const StyledLink = styled.a`
  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.div`
  width: 6.25rem;
  text-align: left;
  font-family: ${typography.fontFamilyDefault};
  font-size: 0.625rem;
  line-height: 0.875rem;
  color: ${colors.blue};
  span {
    text-decoration: underline;
  }
`;

const StyledYoutubeIcon = styled(YouTubeIcon)`
  color: ${colors.redBright};
`;

export const SpeakerListingYoutubeStickyButton = () => {
  return (
    <StyledLink target="_blank" href={youtubeChannel}>
      <Box>
        <StyledYoutubeIcon size={32} />
        <Text>
          Słuchaj podcastów na <span>naszym Youtube</span>
        </Text>
      </Box>
    </StyledLink>
  );
};
